'use strict';

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _flickity = require('flickity');

var _flickity2 = _interopRequireDefault(_flickity);

var _themeVariants = require('@shopify/theme-variants');

var _themeVariants2 = _interopRequireDefault(_themeVariants);

var _themeImages = require('@shopify/theme-images');

var _themeCurrency = require('@shopify/theme-currency');

var _themeSections = require('@shopify/theme-sections');

var _ScrollActions = require('../utils/ScrollActions');

var _Accordion = require('../utils/Accordion');

var _Accordion2 = _interopRequireDefault(_Accordion);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
 * @namespace product
 */

var selectors = {
  addToCart: '[data-cart-add]',
  addToCartText: '[data-add-to-cart-text]',
  comparePrice: '[data-compare-price]',
  comparePriceText: '[data-compare-text]',
  originalSelectorId: '[data-product-select]',
  priceWrapper: '[data-price-wrapper]',
  productFeaturedImage: '[data-product-featured-image]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  productThumbs: '[data-product-single-thumbnail]',
  singleOptionSelector: '[data-single-option-selector]',

  /** Shopify above, additions below */
  addToCartQuantity: '.quantity_number',

  decrease: '.quantity .left',
  increase: '.quantity .right',

  header: '.header',
  miniCart: '.minicart',

  thumbnails: '.thumbnails img',
  featuredImage: '.featimg img',
  mobileImageSlider: '.product__top .images',
  sliderControls: '.product__top .controlbuttons > div',

  stickyHeader: '.product__sticky__header'
};
// import sections from '@shopify/theme-sections';


var quantity = 1;

/**
 * Product section constructor. Runs on page load as well as Theme Editor
 * `section:load` events.
 * @param {string} container - selector for the section container DOM element
 */

(0, _themeSections.register)('product', {
  onLoad: function onLoad() {
    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!(0, _jquery2.default)(selectors.productJson, this.container).html()) {
      return;
    }

    this.productSingleObject = JSON.parse((0, _jquery2.default)(selectors.productJson, this.container).html());

    var options = {
      container: this.container,
      enableHistoryState: true,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.variants = new _themeVariants2.default(options);
    this.$featuredImage = (0, _jquery2.default)(selectors.productFeaturedImage, this.container);

    // this.container.on(
    //   `variantChange${this.namespace}`,
    //   this.updateAddToCartState.bind(this),
    // );
    // this.container.on(
    //   `variantPriceChange${this.namespace}`,
    //   this.updateProductPrices.bind(this),
    // );

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = (0, _themeImages.imageSize)(this.$featuredImage.attr('src'));
      (0, _themeImages.preload)(this.productSingleObject.images, this.settings.imageSize);

      // this.container.on(
      //   `variantImageChange${this.namespace}`,
      //   this.updateProductImage.bind(this),
      // );
    }

    (0, _jquery2.default)(selectors.thumbnails).click(this.setThumbnailAsFeatured);
    this.initializeMobileImageSlider();
    this.stickyHeader.init(this.variants.product);
    this.addToCartInit();
    this.backgroundColor.init();
    this.productImageShadow.init();
    this.ingredientsAccordion.init();
    // this.mobileCartButtonOnScroll();
    // this.ingredientsModalOne.init();
    // this.ingredientsModalTwo.init();
  },


  /** Sections */
  backgroundColor: {
    init: function init() {
      this.sectionOne = document.querySelector('.product__step__wrapper');
      this.colorBackground = document.querySelector('.product__colorbg');

      new _ScrollActions.ScrollTrigger(this.measure.bind(this), this.callback.bind(this));
    },
    measure: function measure(screenTop, screenHeight) {
      var rect = this.sectionOne.getBoundingClientRect();
      var stopY = rect.top + screenTop + 20;
      var startY = stopY - screenHeight;

      return [startY, stopY];
    },
    callback: function callback(percent) {
      this.colorBackground.style.opacity = percent;
    }
  },

  stickyHeader: {
    init: function init(product) {
      this.addToCart = document.querySelector('.product__top ' + selectors.addToCart);
      this.stickyHeader = document.querySelector('.product__sticky__header');
      this.lastPercent = null;

      // Create a trigger to show/hide the sticky bar
      this.trigger = new _ScrollActions.ScrollTrigger(this.measure.bind(this), this.callback.bind(this));

      // Put the requisite data into the sticky bar
      var title = product.title,
          images = product.images,
          _p = product.price;

      var image = images.length && images[0];

      var price = (0, _themeCurrency.formatMoney)(_p, theme.moneyFormat);

      (0, _jquery2.default)(this.stickyHeader).find('img').attr('src', image);
      (0, _jquery2.default)(this.stickyHeader).find('.product__sticky__header__title').text(title);
      (0, _jquery2.default)(this.stickyHeader).find('.product__sticky__header__price').text(price);
      (0, _jquery2.default)(this.stickyHeader).find('.addtocart').click(function () {
        return (0, _jquery2.default)(selectors.addToCart).click();
      });
    },
    measure: function measure(screenTop) {
      var rect = this.addToCart.getBoundingClientRect();
      var startY = screenTop + rect.top;
      var stopY = startY + 1;

      return [startY, stopY];
    },
    callback: function callback(percent) {
      if (percent <= 0) {
        this.stickyHeader.style.visibility = 'hidden';
        this.stickyHeader.style.transition = 'visibility 0s linear .25s,  opacity .25s ease-out';
      } else if (percent > 0 && this.lastPercent <= 0) {
        this.stickyHeader.style.visibility = 'visible';
        this.stickyHeader.style.transition = 'visibility 0s linear,  opacity .25s ease-out 0.1s';
      }

      this.lastPercent = percent;
      this.stickyHeader.style.opacity = percent;
    },
    unload: function unload() {
      this.trigger.destroy();

      (0, _jquery2.default)(this.stickyHeader).find('img').attr('src', '');
      (0, _jquery2.default)(this.stickyHeader).find('.product__sticky__header__title').text(null);
      (0, _jquery2.default)(this.stickyHeader).find('.product__sticky__header__price').text(null);
    }
  },

  productImageShadow: {
    products: [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('.product__image'))),
    init: function init() {
      var _this = this;

      this.products.map(function (scene) {
        new _ScrollActions.ScrollTrigger(_this.measure(scene).bind(_this), _this.callback(scene).bind(_this));
      });
    },
    measure: function measure(scene) {
      return function (screenTop, screenHeight) {
        var rect = scene.getBoundingClientRect();
        var startY = screenTop + rect.top - screenHeight;
        var stopY = screenTop + rect.bottom;
        return [startY, stopY];
      };
    },
    callback: function callback(scene) {
      return function (percent) {
        var tx = -25 * percent + 1;
        var ty = 25 * percent + 2;

        var shadow = scene.querySelector('.product__image svg');

        shadow.style.transform = 'translate3d(' + tx + 'px, ' + ty + 'px, 0)';
      };
    }
  },

  initializeMobileImageSlider: function initializeMobileImageSlider() {
    var _this2 = this;

    var mq = window.matchMedia('(min-width: 865px)');
    this.mobileImageSlider = document.querySelector('.thumbnails');
    var flickOptions = {
      imagesLoaded: true
    };

    if (this.mobileImageSlider) {

      var flick = new _flickity2.default(this.mobileImageSlider, flickOptions);
      this.$sliderControls = (0, _jquery2.default)(selectors.sliderControls);
      this.$sliderControls.each(function (i, ctrl) {
        (0, _jquery2.default)(ctrl).click(function () {
          flick.select(i);
          _this2.$sliderControls.removeClass('active');
          (0, _jquery2.default)(ctrl).addClass('active');
        });
      });

      if (mq.matches) {
        flick.destroy();
      }

      mq.addListener(function (data) {
        if (data.matches) {
          flick.destroy();
        } else {
          flick = new _flickity2.default(_this2.mobileImageSlider, flickOptions);
        }
      });
    }
  },
  onResize: function onResize() {
    if (window.innerWidth < 865) {
      this.mobileImageSlider.addEventListener('scroll', this.onImageSlide);
      this.mobileImageSlider.addEventListener('touchend', this.onSlideEnd);
    } else {
      this.mobileImageSlider.removeEventListener('scroll', this.onImageSlide);
      this.mobileImageSlider.removeEventListener('touchend', this.onSlideEnd);
    }
  },
  onImageSlide: function onImageSlide() {
    var _this3 = this;

    this.doneSliding = false;
    window.clearTimeout(this.slidingTimeout);

    var imagesWrapper = this.mobileImageSlider.querySelector('.thumbnails');
    var imgCount = imagesWrapper.querySelectorAll('img').length;
    var wrapperWidth = imagesWrapper.getBoundingClientRect().width;

    var imgWidth = wrapperWidth / imgCount;
    var scrollLeft = this.mobileImageSlider.scrollLeft;

    this.currentImage = Math.round(scrollLeft / imgWidth);
    this.slidingTimeout = window.setTimeout(function () {
      return _this3.doneSliding = true;
    }, 100);
  },
  onSlideEnd: function onSlideEnd() {
    window.clearTimeout(this.doneSlidingTimeout);
    if (!this.doneSliding) {
      this.doneSlidingTimeout = window.setTimeout(this.onSlideEnd, 110);
      return;
    }
    this.scrollToImage(this.currentImage);
    this.doneSliding = false;
  },
  scrollToImage: function scrollToImage(imageIndex) {
    var $image = (0, _jquery2.default)(selectors.thumbnails).eq(imageIndex);

    var width = $image.width();
    var marginLeft = Number.parseInt($image.css('marginLeft'), 10);

    (0, _jquery2.default)(this.mobileImageSlider).animate({
      scrollLeft: (width + marginLeft) * imageIndex
    }, 250);

    this.$sliderControls.removeClass('active');
    this.$sliderControls.eq(imageIndex).addClass('active');
  },
  setThumbnailAsFeatured: function setThumbnailAsFeatured(event) {
    // Don't run on mobile
    if (window.innerWidth < 865) return;

    (0, _jquery2.default)(selectors.featuredImage)[0].src = event.target.src;
  },
  addToCartInit: function addToCartInit() {
    var _this4 = this;

    quantity = 1;
    (0, _jquery2.default)(selectors.decrease).click(function () {
      return _this4.updateQuantity(-1);
    });
    (0, _jquery2.default)(selectors.increase).click(function () {
      return _this4.updateQuantity(1);
    });

    (0, _jquery2.default)(selectors.addToCart).click(function () {
      (0, _jquery2.default)(selectors.header).addClass('header--black');
      (0, _jquery2.default)(selectors.miniCart).addClass('minicart--open');

      setTimeout(function () {
        (0, _jquery2.default)(selectors.addToCartQuantity).text(1);
        (0, _jquery2.default)(selectors.addToCart).attr('data-cart-quantity', 1);
      }, 300);
    });
  },


  ingredientsAccordion: {
    init: function init() {
      var ingredientSections = [].concat((0, _toConsumableArray3.default)(document.querySelectorAll('.js-ingredients-expand')));
      ingredientSections.map(function (item) {
        return new _Accordion2.default(item, item.dataset.jsTrigger, item.dataset.jsContentBody);
      });
    }
  },

  /** Update the quantity */
  updateQuantity: function updateQuantity(amount) {
    var newQuantity = quantity + amount;
    if (newQuantity < 0) return;

    quantity = newQuantity;
    (0, _jquery2.default)(selectors.addToCartQuantity).text(quantity);
    (0, _jquery2.default)(selectors.addToCart).attr('data-cart-quantity', quantity);
  },


  /**
   * Updates the DOM state of the add to cart button
   *
   * @param {boolean} enabled - Decides whether cart is enabled or disabled
   * @param {string} text - Updates the text notification content of the cart
   */
  updateAddToCartState: function updateAddToCartState(evt) {
    var variant = evt.variant;

    if (variant) {
      (0, _jquery2.default)(selectors.priceWrapper, this.container).removeClass('hide');
    } else {
      (0, _jquery2.default)(selectors.addToCart, this.container).prop('disabled', true);
      (0, _jquery2.default)(selectors.addToCartText, this.container).html(theme.strings.unavailable);
      (0, _jquery2.default)(selectors.priceWrapper, this.container).addClass('hide');
      return;
    }

    if (variant.available) {
      (0, _jquery2.default)(selectors.addToCart, this.container).prop('disabled', false);
      (0, _jquery2.default)(selectors.addToCartText, this.container).html(theme.strings.addToCart);
    } else {
      (0, _jquery2.default)(selectors.addToCart, this.container).prop('disabled', true);
      (0, _jquery2.default)(selectors.addToCartText, this.container).html(theme.strings.soldOut);
    }
  },


  /**
   * Updates the DOM with specified prices
   *
   * @param {string} productPrice - The current price of the product
   * @param {string} comparePrice - The original price of the product
   */
  updateProductPrices: function updateProductPrices(evt) {
    var variant = evt.variant;
    var $comparePrice = (0, _jquery2.default)(selectors.comparePrice, this.container);
    var $compareEls = $comparePrice.add(selectors.comparePriceText, this.container);

    (0, _jquery2.default)(selectors.productPrice, this.container).html((0, _themeCurrency.formatMoney)(variant.price, theme.moneyFormat));

    if (variant.compare_at_price > variant.price) {
      $comparePrice.html((0, _themeCurrency.formatMoney)(variant.compare_at_price, theme.moneyFormat));
      $compareEls.removeClass('hide');
    } else {
      $comparePrice.html('');
      $compareEls.addClass('hide');
    }
  },


  /**
   * Updates the DOM with the specified image URL
   *
   * @param {string} src - Image src URL
   */
  updateProductImage: function updateProductImage(evt) {
    var variant = evt.variant;
    var sizedImgUrl = (0, _themeImages.getSizedImageUrl)(variant.featured_image.src, this.settings.imageSize);

    this.$featuredImage.attr('src', sizedImgUrl);
  },


  /**
   * Event callback for Theme Editor `section:unload` event
   */
  onUnload: function onUnload() {
    this.container.off(this.namespace);

    window.removeEventListener('resize', this.onResize);
    this.mobileImageSlider.removeEventListener('scroll', this.onImageSlide);
    this.stickyHeader.unload();
  }
});